const STORAGE_KEY = "Life@18.sampleMonthName";

const getMonth = () => {
	let month = localStorage.getItem(STORAGE_KEY)
	if (month) return month;
    month = new Date().toLocaleDateString("nl-NL", { month: "long" });
	localStorage.setItem(STORAGE_KEY, month);
	return month;
};

export default getMonth;
